<template><section>
<h1>DatePicker 日期选择器</h1>
<h2>基本用法</h2>
<p>直接通过v-model绑定一个变量即可，可通过顶部的标题栏快捷方式选择年和月</p>
<demo-block>
                    <div class="source" slot="source">        <nt-date-picker v-model="date"></nt-date-picker>
        <p>您当前选择的日期是：{{date}}</p>
        
</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html">        <span class="hljs-tag">&lt;<span class="hljs-name">nt-date-picker</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"date"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-date-picker</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>您当前选择的日期是：{{date}}<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">    
            <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span>{
                data(){
                    <span class="hljs-keyword">return</span> {
                        <span class="hljs-attr">date</span>:<span class="hljs-string">''</span>
                    }
                }
            }
        </span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>禁用</h3>
<p>需要传递disabled属性,Boolean类型</p>
<demo-block>
                    <div class="source" slot="source">        <nt-date-picker v-model="disabledDate" :disabled="true"></nt-date-picker>
        <p>您当前选择的日期是：{{disabledDate}}</p>
        
</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html">        <span class="hljs-tag">&lt;<span class="hljs-name">nt-date-picker</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"disabledDate"</span> <span class="hljs-attr">:disabled</span>=<span class="hljs-string">"true"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-date-picker</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>您当前选择的日期是：{{disabledDate}}<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">    
            <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span>{
                data(){
                    <span class="hljs-keyword">return</span> {
                       <span class="hljs-attr">disabledDate</span>:<span class="hljs-string">'2018-09-11'</span>
                    }
                }
            }
        </span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>change事件</h3>
<demo-block>
                    <div class="source" slot="source">        <nt-date-picker v-model="date" @change="handleChange"></nt-date-picker>
        <p>您当前选择的日期是：{{date}}</p>
        
</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html">        <span class="hljs-tag">&lt;<span class="hljs-name">nt-date-picker</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"date"</span> <span class="hljs-attr">@change</span>=<span class="hljs-string">"handleChange"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-date-picker</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>您当前选择的日期是：{{date}}<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">    
            <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span>{
                data(){
                    <span class="hljs-keyword">return</span> {
                        <span class="hljs-attr">date</span>:<span class="hljs-string">''</span>
                    }
                },
                <span class="hljs-attr">methods</span>:{
                    handleChange(val){
                        alert(<span class="hljs-string">`日期选择后的新值为<span class="hljs-subst">${val}</span>`</span>)
                    }
                }
            }
        </span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>Attributes</h3>
<table>
<thead>
<tr>
<th style="text-align:left">参数</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">类型</th>
<th style="text-align:left">可选值</th>
<th style="text-align:left">默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">placeholder</td>
<td style="text-align:left">占位符</td>
<td style="text-align:left">string</td>
<td style="text-align:left">-</td>
<td style="text-align:left"><code v-pre>选择日期</code></td>
</tr>
<tr>
<td style="text-align:left">disabled</td>
<td style="text-align:left">按钮是否禁用</td>
<td style="text-align:left">boolean</td>
<td style="text-align:left"><code v-pre>true</code> <code v-pre>false</code></td>
<td style="text-align:left"><code v-pre>false</code></td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th style="text-align:left">事件名称</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">change</td>
<td style="text-align:left">日期选择值改变触发</td>
<td style="text-align:left">改变后的新值</td>
</tr>
</tbody>
</table>
</section></template>

<script>
export default{
    data(){
        return {
           date:'',
           disabledDate:'2018-09-11'
        }
    },
    methods:{
        handleChange(val){
            alert(`日期选择后的新值为${val}`)
        }
    }
}
</script>